//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      formLayout: 'horizontal',
      item: {
        type: 2
      }
    }
  },
  created() {
    const cookies = this.$role.showCookies()
    if (!cookies) {
      this.$router.push('login')
    } else {
      this.$role.saveGlobal(cookies)
    }
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this
      if (formLayout === 'horizontal') {
        return {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 }
        }
      } else {
        return {}
      }
    },
    buttonItemLayout() {
      const { formLayout } = this
      if (formLayout === 'horizontal') {
        return { wrapperCol: { span: 14, offset: 4 } }
      } else {
        return {}
      }
    }
  },
  methods: {
    submitForm() {
      if (!this.item.pass) {
        this.$toast('密码不能为空')
        return false
      }
      if (this.item.pass !== this.item.againPass) {
        this.$toast('两次输入的密码不一致')
        return false
      }
      let that = this
      let param = this.item
      param.user_tel = global.userTel
      param.type = global.type
      console.log(this.param)
      this.$http
        .post(global.HTTP + 'login/setPass', param)
        .then(function(resp) {
          if (resp.data.code === 0) {
            that.$message.success('密码设置成功', 1)
            setTimeout(function() {
              that.$router.push('index')
            }, 2500)
          } else {
            that.$toast(resp.data.msg)
          }
        })
        .catch(function(err) {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/login/setPass.vue